import {translations} from 'presentation/translations-new';
import {parseDate} from 'presentation/utils';
import * as z from 'zod';
import {zodDateValidators} from '../utils/dateValidators';

const {selectAnOption} = translations['pt-br'].commons;
const {invalidDate, invalidFutureDate, invalidCancellationDate} =
	translations['pt-br'].privateFlow.consultRefund;
const {atLeastOneSession} =
	translations['pt-br'].privateFlow.refund.receiptRegistrationPage.patientData;

const baseTherapyDataSchema = z.object({
	therapyType: z.object(
		{
			code: z.string().min(1),
			description: z.string().min(1),
		},
		{message: selectAnOption},
	),
	sessions: z
		.array(
			z.object({
				serviceDate: z
					.string()
					.optional()
					.or(z.literal(''))
					.refine(zodDateValidators.isValidFormat, {message: invalidDate})
					.refine(zodDateValidators.isAfterMinDate, {message: invalidDate})
					.refine(zodDateValidators.isNotFutureDate, {message: invalidFutureDate}),
				sessionValue: z.string().optional().or(z.literal('')),
				id: z.string().optional(),
				isSaved: z.boolean().optional(),
			}),
		)
		.min(1, {message: atLeastOneSession})
		.refine(
			sessions =>
				sessions.some(
					session =>
						session.serviceDate &&
						session.serviceDate.trim() !== '' &&
						session.sessionValue &&
						session.sessionValue.trim() !== '',
				),
			{message: atLeastOneSession},
		),
});

export const therapyDataSchema = (dtCancelamento?: string) =>
	baseTherapyDataSchema.superRefine((data, ctx) => {
		const maxServiceDate = dtCancelamento ? parseDate(dtCancelamento) : undefined;

		data.sessions.forEach((session, index) => {
			const serviceDate = parseDate(session.serviceDate);

			if (maxServiceDate && serviceDate && serviceDate >= maxServiceDate) {
				ctx.addIssue({
					path: ['sessions', index, 'serviceDate'],
					message: invalidCancellationDate,
					code: z.ZodIssueCode.custom,
				});
			} else if (!maxServiceDate && serviceDate && serviceDate > new Date()) {
				ctx.addIssue({
					path: ['sessions', index, 'serviceDate'],
					message: invalidFutureDate,
					code: z.ZodIssueCode.custom,
				});
			}
		});
	});

export type TherapyDataSchema = z.infer<typeof baseTherapyDataSchema>;
